import type { Gender } from '@/sections/forms/multistep-form/form/types';

export const RECALL_TIME_OPTIONS = [
  { value: '09:00-12:00', label: '09:00 - 12:00' },
  { value: '12:00-14:00', label: '12:00 - 14:00' },
  { value: '14:00-17:00', label: '14:00 - 17:00' },
] as const;

export type RecallTimeValue = (typeof RECALL_TIME_OPTIONS)[number]['value'];

export const TERMIN_FORM_DEFAULT_VALUES = {
  recallDate: '',
  recallTime: '' as RecallTimeValue | '',
  name: '',
  surname: '',
  email: '',
  phoneNumber: '',
  birthDate: '',
  gender: '' as Gender | '',
  termsAndConditions: false,
};

export type TerminFormValues = typeof TERMIN_FORM_DEFAULT_VALUES;
